import http from '@/utils/http'

export function getAnswerResults(params){
    return  http('/answerResults',{params})
}

export function getAnswerResultsDetail(id){
    return  http(`/answerResults/${id}`)
}